import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=6f7b6350&"
import script from "./InvoiceList.vue?vue&type=script&lang=js&"
export * from "./InvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports